'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var FormField = (function (_React$Component) {
    _inherits(FormField, _React$Component);

    function FormField(props) {
        _classCallCheck(this, FormField);

        _get(Object.getPrototypeOf(FormField.prototype), 'constructor', this).call(this, props);
        this.displayName = 'FormField';
    }

    _createClass(FormField, [{
        key: 'render',
        value: function render() {
            // classes
            var componentClass = (0, _classnames2['default'])('FormField', {
                'offset-absent-label': this.props.offsetAbsentLabel,
                error: this.props.error
            }, this.props.width, this.props.className);

            // props
            var props = (0, _blacklist2['default'])(this.props, 'className', 'label', 'offsetAbsentLabel', 'width');

            // elements
            var componentLabel = this.props.label ? _react2['default'].createElement(
                'label',
                { className: 'FormLabel', htmlFor: this.props.id || this.props.htmlFor },
                this.props.label
            ) : null;

            return _react2['default'].createElement(
                'div',
                _extends({ className: componentClass }, props),
                componentLabel,
                this.props.children
            );
        }
    }]);

    return FormField;
})(_react2['default'].Component);

FormField.propTypes = {
    className: _propTypes2['default'].string,
    error: _propTypes2['default'].bool,
    htmlFor: _propTypes2['default'].string,
    id: _propTypes2['default'].string,
    label: _propTypes2['default'].string,
    offsetAbsentLabel: _propTypes2['default'].bool,
    width: _propTypes2['default'].oneOf(['one-half', 'two-quarters', 'three-sixths', 'one-quarter', 'three-quarters', 'one-third', 'two-sixths', 'two-thirds', 'four-sixths', 'one-fifth', 'two-fifths', 'three-fifths', 'four-fifths', 'one-sixth', 'five-sixths'])
};

module.exports = FormField;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/FormField.js
// module id = 303
// module chunks = 0